<div class="offline-container">
  <div class="text-wrap">
    <p class="offline-text">You need to be online to view this section</p>
    <p class="offline-text">Please check your network connection</p>
  </div>

  <button slot="center"
              (click)="onViewButtonClick()"
              color="medium"
              shape="round"
              class="offline-button">
    <i class="fas fa-mobile-alt icon"></i>
    View Downloaded Deliveries
  </button>
</div>
